import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
import i18n from "@/helpers/i18n";

export interface Banner {
  id: string,
  title: string,
  url: string,
  imageKey: string,
  priority: string,
  createdAt: string
}

export interface State {
  banners: Banner[] | null
}


const defaultState: State = {
  banners: null
};

const getters = {
  banners: (state: State) => state.banners
}

const mutations: MutationTree<State> = {
  setBanners(state: State, payload: [Banner]) {
    state.banners = payload
  },
  deleteBanners(state: State, payload: string) {

    if (state.banners) {

      const arr: Banner[] = state.banners.filter((v: any) => v.id != payload)
      state.banners = arr
    }

  },
  addBanner(state: State, payload: Banner) {
    if (state.banners) state.banners.push(payload)

  },
  editBanner(state: State, payload: Banner){
    if(state.banners){
      state.banners.map((element:Banner)=>{
        if(element.id === payload.id){
          return payload
        }
      })
    }


  }
}

const actions: ActionTree<State, RootState> = {
  async loadBannersFromServer({commit, state}, payload: string) {
    try {
      const {data} = await Vue.axios.get('/v4/show/'+payload+'/advertising-banner')
      commit('setBanners', data.data)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('advertising.notifications.banners_loaded')]
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
    }
  },
  async deleteBannerFromServer({commit, state}, payload: string) {
    try {
      const {data} = await Vue.axios.delete('/v4/show/advertising-banner/' + payload)
      if (data.data.status === 'ok') {
        commit('deleteBanners', payload)
        this.commit('alerts/setAlert', {
          show: true,
          messages: [i18n.t('advertising.notifications.banners_deleted')]
        })
      } else {
        throw(data)
      }

      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
      return false
    }
  },
  async saveBannerFromServer({commit, state}, payload: any) {
    const code:string = payload.code
    delete payload.code

    try {
      const {data} = await Vue.axios.post('/v4/show/'+code+'/advertising-banner', payload)
      commit('addBanner', data.data)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('advertising.notifications.add_pushes')]
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
      return false
    }
  },
  async changeBannerFromServer({commit, state}, payload: any) {

    try {
      const {data} = await Vue.axios.patch('/v4/show/advertising-banner/'+ payload.id,payload)
      commit('editBanner', data.data)
      this.commit('alerts/setAlert', {
        show: true,
        messages: [i18n.t('advertising.notifications.banner_change')]
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e.message]
      })
      return false
    }
  },


}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
